// !function(){"use strict";var e={4105:function(e,t,r){r.d(t,{Ds:function(){return c},Q2:function(){return n},wz:function(){return o}});const n=function(){return{method:"POST",headers:{"Content-Type":"application/json",Accept:`application/${arguments.length>0&&void 0!==arguments[0]?arguments[0]:"json"}`}}},o=async function(){let e,t;try{e=await fetch(...arguments)}catch(e){t=e}return{response:e,error:t}};function c(e,t){const r=this;let n;return function(){for(var o=arguments.length,c=new Array(o),a=0;a<o;a++)c[a]=arguments[a];clearTimeout(n),n=setTimeout((function(){return e.apply(r,c)}),t)}}document.querySelectorAll(".local-scroll").forEach((e=>{e.addEventListener("click",(e=>{e.preventDefault(),e.stopPropagation();const t=e.target.getAttribute("href");(e=>{Math.easeInOutQuad=function(e,t,r,n){return(e/=n/2)<1?r/2*e*e+t:-r/2*(--e*(e-2)-1)+t};const t=document.getElementById("grid-archive-header"),r=document.getElementById("nav-wrapper");let n=0,o=0;t&&(n=t.offsetHeight+50),r&&(o=r.offsetHeight+50);const c=e.offsetTop-n-o,a=window.scrollY,i=c-a;let s=0;const l=()=>{s+=5;const e=Math.easeInOutQuad(s,a,i,200);window.scrollTo(0,e),s<200&&setTimeout(l,5)};l()})(document.querySelector(t))}))}))}},t={};function r(n){var o=t[n];if(void 0!==o)return o.exports;var c=t[n]={exports:{}};return e[n](c,c.exports,r),c.exports}r.d=function(e,t){for(var n in t)r.o(t,n)&&!r.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]})},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},function(){var e=r(4105);class t extends HTMLElement{constructor(){super(),this.items=Array.from(this.querySelectorAll(".cart-item")),this.items.forEach((e=>this.manageState(e))),this.selectorsToUpdate=[".cart-summary__header","#cart-total-price","#checkout",".cart-summary__free-shipping"],this.mainCartSelector=".shopify-section.cart",this.miniCartSelector="#mini-cart",this.itemsContainersSelector=".cart-items-container, .mini-cart--empty",this.parser=new DOMParser}manageState(e){const t=e.getAttribute("data-variant-id");e.querySelector(".cart-item-delete, .cart-item__remove").addEventListener("click",(async()=>{await this.changeCartItem({id:t,quantity:0}),e.remove()}));const r=e.querySelector('input[name="quantity"]');if(!r)return;const n=e.querySelector('button[name="plus"]'),o=e.querySelector('button[name="minus"]');let c=parseInt(r.value);n.addEventListener("click",(()=>{c+=1,r.value=c,this.changeCartItem({id:t,quantity:c})})),o.addEventListener("click",(()=>{c-=1,r.value=c,this.changeCartItem({id:t,quantity:c})}))}async changeCartItem(t){const{response:r,error:n}=await(0,e.wz)(`${routes.cartChange}`,{...(0,e.Q2)(),body:JSON.stringify({line:+t.id,quantity:t.quantity,sections:"main-cart,navigation-main"})});if(n)return void console.error(n);const o=await r.json(),c=this.parser.parseFromString(o.sections["main-cart"],"text/html"),a=this.parser.parseFromString(o.sections["navigation-main"],"text/html");if(0===o.item_count){document.querySelector(this.mainCartSelector)&&(document.querySelector(this.mainCartSelector).innerHTML=c.querySelector(this.mainCartSelector).innerHTML);const e=document.querySelector("#mini-cart");e&&(e.innerHTML=a.querySelector("#mini-cart").innerHTML);const t=document.querySelector("drawer-component");return t&&(t.connect(),t.attachOverlay()),document.querySelectorAll("#mini-cart .icon").forEach((e=>e.classList.add("loaded"))),void this.renderElements(c)}this.renderItems(c)}renderElements(e){this.selectorsToUpdate.forEach((t=>{try{const r=document.querySelectorAll(t),n=e.querySelector(t);r.length&&n&&r.forEach((e=>{n.querySelectorAll(".icon").forEach((e=>e.classList.add("loaded"))),e.replaceWith(n.cloneNode(!0))}))}catch(e){console.error(`Error updating ${t}`,e)}}));const t=e.querySelector(".cart-count");document.querySelectorAll("#cart-open-block .header__icons--cart-open .cart-count").forEach((e=>{t?(e.classList.contains("visually-hidden")&&e.classList.remove("visually-hidden"),e.textContent=t.textContent):e.classList.add("visually-hidden")})),document.querySelector("#cart-open-block .icon").classList.add("loaded")}renderItems(e){this.renderElements(e);const t=Array.from(document.querySelectorAll(this.itemsContainersSelector)),r=e.querySelector(this.itemsContainersSelector);t.forEach((e=>{e&&e.replaceWith(r.cloneNode(!0))})),document.querySelectorAll(".cart-item").forEach((e=>{e.querySelectorAll(".icon").forEach((e=>e.classList.add("loaded"))),this.manageState(e)}))}}customElements.get("cart-service")||customElements.define("cart-service",t),customElements.get("cart-note")||customElements.define("cart-note",class extends HTMLElement{constructor(){super(),this.addEventListener("change",(0,e.Ds)((t=>{const r=JSON.stringify({note:t.target.value});fetch(`${routes.cart_update_url}`,{...(0,e.Q2)(),body:r})}),300))}})}()}();

!function() {
    "use strict";


    var e = {
        4105: function(e, t, r) {
            r.d(t, {
                Ds: function() {
                    return c;
                },
                Q2: function() {
                    return n;
                },
                wz: function() {
                    return o;
                }
            });
            const n = function() {
                    return {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Accept: `application/${arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "json"}`
                        }
                    };
                },
                o = async function() {
                    let e, t;
                    try {
                        e = await fetch(...arguments);
                    } catch (e) {
                        t = e;
                    }
                    return {
                        response: e,
                        error: t
                    };
                };

            function c(e, t) {
                const r = this;
                let n;
                return function() {
                    for (var o = arguments.length, c = new Array(o), a = 0; a < o; a++) c[a] = arguments[a];
                    clearTimeout(n), n = setTimeout((function() {
                        return e.apply(r, c);
                    }), t);
                };
            }

            // Scroll functionality (unchanged)
            document.querySelectorAll(".local-scroll").forEach((e => {
                e.addEventListener("click", (e => {
                    e.preventDefault(), e.stopPropagation();
                    const t = e.target.getAttribute("href");
                    (e => {
                        Math.easeInOutQuad = function(e, t, r, n) {
                            return (e /= n / 2) < 1 ? r / 2 * e * e + t : -r / 2 * (--e * (e - 2) - 1) + t;
                        };
                        const t = document.getElementById("grid-archive-header"),
                            r = document.getElementById("nav-wrapper");
                        let n = 0,
                            o = 0;
                        t && (n = t.offsetHeight + 50), r && (o = r.offsetHeight + 50);
                        const c = e.offsetTop - n - o,
                            a = window.scrollY,
                            i = c - a;
                        let s = 0;
                        const l = () => {
                            s += 5;
                            const e = Math.easeInOutQuad(s, a, i, 200);
                            window.scrollTo(0, e), s < 200 && setTimeout(l, 5);
                        };
                        l();
                    })(document.querySelector(t));
                }));
            }));
        }
    },
    t = {};

    function r(n) {
        var o = t[n];
        if (void 0 !== o) return o.exports;
        var c = t[n] = {
            exports: {}
        };
        return e[n](c, c.exports, r), c.exports;
    }

    r.d = function(e, t) {
            for (var n in t) r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
            });
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        },
        function() {
            var e = r(4105);


async function updateUpsellProducts() {
    try {
        const response = await fetch("/cart.js");
        if (!response.ok) throw new Error(`Error fetching cart data: ${response.status} ${response.statusText}`);

        const cartData = await response.json();
        const cartItems = cartData.items || [];
        const cartTotal = cartData.total_price / 100;

        const upsellCartUpsell = document.querySelector(".upsell-section.cart-upsell");
        const upsellSuperfood = document.querySelector(".upsell-section.superfood-supplements");
        const swiperWrapper = upsellSuperfood?.querySelector(".swiper-wrapper");

        if (cartItems.length === 0) {
            upsellSuperfood?.classList.add("hidden");
            if (upsellSwiper) {
                upsellSwiper.destroy(true, true);
                upsellSwiper = null;
            }
            return;
        }

        // Toggle upsells
            if (cartTotal < 1200) {
                upsellCartUpsell.style.display = "block";
                upsellSuperfood.style.display = "none";
            } else {
                upsellCartUpsell.style.display = "none";
                upsellSuperfood.style.display = "block";

                const specialSlide = swiperWrapper?.querySelector('[data-special="true"]');

                if (specialSlide) {
                    if (cartTotal >= 2000) {
                        specialSlide.style.display = "";   // show
                    } else {
                        specialSlide.style.display = "none"; // hide
                    }
                }
            }

                    // Re-init or update swiper
                    if (document.querySelector(".upsell-swiper")) {
                        initializeSwiper();
                    }
                } catch (error) {
                    console.error("Error in updateUpsellProducts:", error);
                }

                // Hide sachets-text inside special slide if present
const specialSlide = document.querySelector('.swiper-slide[data-special="true"]');
if (specialSlide) {
    const sachetsText = specialSlide.querySelector('.sachets-text');
    if (sachetsText) {
        sachetsText.style.display = "none";
    }
}
            }



// async function updateUpsellProducts() {
//     try {
//         const response = await fetch("/cart.js");
//         if (!response.ok) throw new Error(`Error fetching cart data: ${response.status} ${response.statusText}`);

//         const cartData = await response.json();
//         const cartItems = cartData.items || [];
//         const cartTotal = cartData.total_price / 100;
//         const cartTitles = cartItems.map(item => item.product_title.trim().toLowerCase());

//         const upsellCartUpsell = document.querySelector(".upsell-section.cart-upsell");
//         const upsellSuperfood = document.querySelector(".upsell-section.superfood-supplements");

//         if (cartItems.length === 0) {
//             // If the cart is empty, hide both upsell sections
//             upsellSuperfood?.classList.add("hidden");

//             // Destroy Swiper if cart is empty
//             if (upsellSwiper) {
//                 upsellSwiper.destroy(true, true);
//                 upsellSwiper = null;
//                 console.log("Swiper destroyed due to empty cart.");
//             }
//             return;
//         }

//         // Show/hide upsells based on cart value
//         upsellCartUpsell.style.display = cartTotal < 1200 ? "block" : "none";
//         upsellSuperfood.style.display = cartTotal < 1200 ? "none" : "block";

//         // Initialize Swiper only if upsell section exists
//         if (document.querySelector(".upsell-swiper")) {
//             initializeSwiper();
//         } else {
//             console.warn("Upsell swiper not found, skipping initialization.");
//         }
//     } catch (error) {
//         console.error("Error in updateUpsellProducts:", error);
//     }
// }





          
// window.addEventListener('beforeunload', () => {
//     console.log("Back button pressed, refreshing the page with cache-busting...");

//     // Add a unique cache-busting parameter
//     const url = new URL(window.location.href);
//     url.searchParams.set('_refresh', new Date().getTime()); // Add a timestamp as a query parameter

//     // Reload the page with the updated URL
//     window.location.href = url.toString();
// });


// Select the cart section or any DOM element that updates when the cart changes
const cartElement = document.querySelector('.mini-cart__content') || document.querySelector('.cart-items-container');

if (cartElement) {
    const observer = new MutationObserver(() => {
        updateUpsellProducts();

        // Delay swiper initialization to ensure DOM updates complete
        setTimeout(() => {
            if (document.querySelector(".upsell-swiper")) {
                initializeSwiper();
            }
        }, 500);
    });

    observer.observe(cartElement, {
        childList: true,
        subtree: true,
    });
}


let upsellSwiper;

function initializeSwiper() {
    if (typeof Swiper === "undefined") {
        console.error("Swiper is not defined. Ensure Swiper is loaded before initializing.");
        return;
    }

    new Swiper('.upsell-swiper', {
        slidesPerView: 2.5,
        spaceBetween: 10,
         navigation: {
              nextEl: '.up-swiper-button-next',
              prevEl: '.up-swiper-button-prev',
          },
        pagination: false,
    });
}

// Run Swiper on page load
document.addEventListener("DOMContentLoaded", () => {
    updateUpsellProducts();
  initializeSwiper();
});

          
function initializeProductFormScript() {
    console.log("Reinitializing product form script...");

    const forms = document.querySelectorAll('form[action="/cart/add"]'),
        mainCart = document.getElementById("main-cart"),
        overlay = document.getElementById("overlay"),
        miniCart = document.getElementById("mini-cart"),
        cartService = document.querySelector("cart-service"),
        body = document.querySelector("body"),
        closeCart = () => {
            miniCart.classList.remove("open");
            overlay.classList.remove("open");
            body.style.removeProperty("overflow");
            hO(false);
        };

    if (!forms.length) return;

    forms.forEach((form) => {
        form.addEventListener("submit", async (event) => {
            event.preventDefault();

            const submitButton = event.target.querySelector('button[type="submit"]');
            const buttonText = submitButton.querySelector('span:not(.cart-icon):not(:empty)');
            const cartIcon = submitButton.querySelector('span.cart-icon');
            const loadingIcon = submitButton.querySelector('svg.loading-icon');
            const errorContainer = event.target.querySelector(".product-converter__error");

            // Show loading state
            if (buttonText) buttonText.textContent = cartStrings.addingToCart;
            submitButton.classList.add("added");
            cartIcon.style.display = "none";
            loadingIcon.style.display = "block";

            // Prepare AJAX request
            const requestOptions = Q2("javascript"); // Q2 function should be globally accessible
            if (!requestOptions) {
                console.error("Error: Q2 function is undefined.");
                return;
            }
            requestOptions.headers["X-Requested-With"] = "XMLHttpRequest";
            delete requestOptions.headers["Content-Type"];

            const formData = new FormData(form);
            formData.append("sections", "main-cart");
            requestOptions.body = formData;

            try {
                const response = await fetch(routes.cartAdd, requestOptions);
                const result = await response.json();

                // Reset loading state
                cartIcon.style.display = "inline-flex";
                loadingIcon.style.display = "none";
                submitButton.classList.remove("added");

                if (result.status) {
                    if (buttonText) buttonText.textContent = cartStrings.addToCart;
                    errorContainer.innerHTML = `<span class="icon loaded">error</span><p>${typeof result.description === "object" ? Object.values(result.description).join(", ") : result.description}</p>`;
                } else {
                    if (cartStrings.uxCart === "cart") {
                        window.location.href = routes.cart;
                        return;
                    }

                    errorContainer.innerHTML = "";
                    if (mainCart) mainCart.classList.add("added");
                    if (cartService) {
                        cartService.renderItems(new DOMParser().parseFromString(result.sections["main-cart"], "text/html"));
                    }

                    if (cartStrings.uxCart === "mini-cart") {
                        if (miniCart) miniCart.classList.add("open");
                        if (overlay) overlay.classList.add("open", "overlay--all");
                        hO(true);
                        gp(true, closeCart);
                    }

                    if (buttonText) buttonText.textContent = cartStrings.addedToCart;
                    submitButton.classList.add("successful");
                }
              updateUpsellProducts()
            } catch (error) {
                console.error("Error adding to cart:", error);
                cartIcon.style.display = "inline-flex";
                loadingIcon.style.display = "none";
                if (buttonText) buttonText.textContent = cartStrings.addToCart;
            }
        });
    });
  
}


            class t extends HTMLElement {
                constructor() {
                    super();
                    this.items = Array.from(this.querySelectorAll(".cart-item"));
                    this.items.forEach((e => this.manageState(e)));
                    this.selectorsToUpdate = [".cart-summary__header", "#cart-total-price", "#checkout", ".cart-summary__free-shipping"];
                    this.mainCartSelector = ".shopify-section.cart";
                    this.miniCartSelector = "#mini-cart";
                    this.itemsContainersSelector = ".cart-items-container, .mini-cart--empty";
                    this.parser = new DOMParser;

                    // Update upsell on initialization
                    updateUpsellProducts();
                }

                manageState(e) {
                    const t = e.getAttribute("data-variant-id");
                    const deleteBtn = e.querySelector(".cart-item-delete, .cart-item__remove");
                    if (deleteBtn) {
                        deleteBtn.addEventListener("click", async () => {
                            await this.changeCartItem({ id: t, quantity: 0 });
                            e.remove();
                        });
                    }
                    const r = e.querySelector('input[name="quantity"]');
                    if (!r) return;
                    const n = e.querySelector('button[name="plus"]'),
                        o = e.querySelector('button[name="minus"]');
                    let c = parseInt(r.value);
                    n.addEventListener("click", (() => {
                        c += 1, r.value = c, this.changeCartItem({
                            id: t,
                            quantity: c
                        });
                    })), o.addEventListener("click", (() => {
                        c -= 1, r.value = c, this.changeCartItem({
                            id: t,
                            quantity: c
                        });
                    }));
                }





              
async changeCartItem(t) {
    console.log("Changing cart item:", t);

    const { response: r, error: n } = await (0, e.wz)(`${routes.cartChange}`, {
        ...(0, e.Q2)(),
        body: JSON.stringify({
            line: +t.id,
            quantity: t.quantity,
            sections: "main-cart,navigation-main"
        })
    });

    if (n) {
        console.error("Cart change error:", n);
        return;
    }

    const o = await r.json();
    console.log("Cart update response:", o);

    const c = this.parser.parseFromString(o.sections["main-cart"], "text/html");
    const a = this.parser.parseFromString(o.sections["navigation-main"], "text/html");

    const mainCart = document.querySelector(this.mainCartSelector);
    const miniCart = document.querySelector("#mini-cart");

    if (o.item_count === 0) {
        console.log("Cart is empty, updating UI...");

        if (mainCart) {
            const mainCartContent = c.querySelector(this.mainCartSelector);
            if (mainCartContent) {
                mainCart.innerHTML = mainCartContent.innerHTML;
            } else {
                mainCart.innerHTML = "<p>Your cart is empty.</p>";
            }
        }

        if (miniCart) {
            const miniCartContent = a.querySelector("#mini-cart");
            if (miniCartContent) {
                miniCart.innerHTML = miniCartContent.innerHTML;
            } else {
                miniCart.innerHTML = "<p>Your cart is empty.</p>";
            }
        }

        const drawer = document.querySelector("drawer-component");
        if (drawer) {
            drawer.connect();
            drawer.attachOverlay();
        }

        document.querySelectorAll("#mini-cart .icon").forEach((el) => el.classList.add("loaded"));

        this.renderElements(c);
        initializeSwiper();
        // **Call the product form script when the cart is empty**
        initializeProductFormScript();  
    } else {
        console.log("Cart has items, rendering new cart items...");
        this.renderItems(c);
    }

    // Ensure upsell products update properly
    updateUpsellProducts();
}




                renderElements(e) {
                    this.selectorsToUpdate.forEach((t => {
                        try {
                            const r = document.querySelectorAll(t),
                                n = e.querySelector(t);
                            r.length && n && r.forEach((e => {
                                n.querySelectorAll(".icon").forEach((e => e.classList.add("loaded"))), e.replaceWith(n.cloneNode(!0));
                            }));
                        } catch (e) {
                            console.error(`Error updating ${t}`, e);
                        }
                    }));
                    const t = e.querySelector(".cart-count");
                    document.querySelectorAll("#cart-open-block .header__icons--cart-open .cart-count").forEach((e => {
                        t ? (e.classList.contains("visually-hidden") && e.classList.remove("visually-hidden"), e.textContent = t.textContent) : e.classList.add("visually-hidden");
                    })), document.querySelector("#cart-open-block .icon").classList.add("loaded");
                }

                renderItems(e) {
                  this.renderElements(e);
              
                  const containers = Array.from(document.querySelectorAll(this.itemsContainersSelector));
                  const newContent = e.querySelector(this.itemsContainersSelector);
              
                  if (!newContent) {
                      console.warn("No cart items found, possibly an empty cart.");
                      return;
                  }
              
                  containers.forEach((container) => {
                      container.replaceWith(newContent.cloneNode(true));
                  });
              
                  document.querySelectorAll(".cart-item").forEach((item) => {
                      item.querySelectorAll(".icon").forEach((icon) => icon.classList.add("loaded"));
                      this.manageState(item);
                  });
              }
            }
            customElements.get("cart-service") || customElements.define("cart-service", t);
            customElements.get("cart-note") || customElements.define("cart-note", class extends HTMLElement {
                constructor() {
                    super(), this.addEventListener("change", (0, e.Ds)((t => {
                        const r = JSON.stringify({
                            note: t.target.value
                        });
                        fetch(`${routes.cart_update_url}`, {
                            ...(0, e.Q2)(),
                            body: r
                        });
                    }), 300));
                }
            });
        }();
}();